<template>
	<v-row
		dense
		:style="{ 'max-height': roleIsSystemAdmin ? 'calc(100vh - 115px) !important' : 'calc(100vh - 60px) !important' }"
		class="pa-2 ma-0">
		<v-dialog v-model="dialog" max-width="350">
			<v-card>
				<v-card-title
					class="font-size16 white--text my-0 py-0"
					style="background-color: #a51717; height: 40px !important">
					{{ $t('create-staff') }}
				</v-card-title>
				<v-card-text class="font-size15 d-flex flex-column mt-2">
					{{ $t('are-you-sure-the-staff') }} "{{ staff?.userFirstName }} {{ staff?.userLastName }}"
					{{ $t('is-not-mapped') }} ?
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn small @click="dialog = false">
						{{ $t('cancel') }}
					</v-btn>
					<v-btn class="white--text" small color="chips" @click="confirmCreate">
						{{ $t('create') }}
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-dialog v-model="deleteDialog" max-width="350">
			<v-card>
				<v-card-title
					class="font-size16 white--text my-0 py-0"
					style="background-color: #a51717; height: 40px !important">
					{{ $t('delete-ecp-staff-mapping') }}
				</v-card-title>
				<v-card-text class="font-size15 d-flex flex-column">
					{{ $t('are-you-sure-you-want-to-delete-this-staff-mapping') }}?
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn small @click="deleteDialog = false">
						{{ $t('cancel') }}
					</v-btn>
					<v-btn class="white--text" small color="chips" @click="confirmDeletion">
						{{ $t('delete') }}
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<!-- TODO:  With Update Table -->
		<v-col
			cols="6"
			:style="{
				height: selectedEcpUser !== null && selectedNotMappedUser !== null ? height : '50%',
			}">
			<v-card elevation="5" height="100%" ref="ecpUsersTable" @resize="updateDataTableHeight">
				<div class="d-flex justify-space-between elevation-3">
					<div class="d-flex align-center">
						<v-img :src="ecp" class="ml-2" max-height="21" max-width="22" />
						<div class="text-left ml-2 font-weight-bold font-size16">
							{{ $t('unmapped-users-from-ecp') }}
						</div>
					</div>
					<div>
						<v-text-field
							single-line
							outlined
							class="py-1 px-1"
							prepend-inner-icon="mdi-magnify"
							hide-details
							dense
							v-model="searchEcpMedicalStaff"
							:label="$t('search')" />
					</div>
				</div>
				<v-divider />
				<v-radio-group class="small" hide-details v-model="selectedEcpUser">
					<v-data-table
						:loading="loading"
						:headers="ecpHeaders"
						:items="unfiltered.usersNeedToBeMapped"
						:search="searchEcpMedicalStaff"
						:height="tableHeight"
						fixed-header
						:footer-props="getDataTableFooterProps('medicalStaffMappingTable')"
						:items-per-page="-1"
						:no-data-text="$t('no-data-available')">
						<template #item="{ item, index }">
							<tr :class="getOddRows(index)">
								<td style="height: 30px !important" class="table-font-size px-2 py-0">
									<div class="d-flex">
										<v-img class="mr-2" :src="PatientBlack" max-width="13px" max-height="20px" />
										{{ item.userFirstName }} {{ item.userLastName }}
									</div>
								</td>
								<td style="height: 30px !important" class="table-font-size">
									{{ item.userEmail }}
								</td>
								<td style="height: 30px !important" class="table-font-size">
									{{ item.userPhoneCell }}
								</td>
								<td style="height: 30px !important">{{ item.userRole }}</td>
								<td style="height: 30px !important" class="table-font-size px-2">
									<v-tooltip bottom v-if="item.userMapSuggestion?.score >= 5">
										<template #activator="{ on, attrs }">
											<div
												v-bind="attrs"
												v-on="on"
												class="d-flex align-center justify-center"
												v-if="item.userMapSuggestion?.score >= 5">
												<v-radio :value="item" @click="filterByRole(item)"></v-radio>
											</div>
										</template>
										<div class="pa-2 text-left" style="max-width: 300px; white-space: normal">
											<strong>{{ $t('suggested-to-map-with') }}:</strong><br /><br />
											<span>{{ item.userMapSuggestion.localUserFullName }}</span>
											<div v-if="item.userMapSuggestion.evidence?.length">
												<span>{{ $t('evidence') }}:</span>
												<ul class="ma-0 pa-0 pl-4">
													<li v-for="(ev, idx) in item.userMapSuggestion.evidence" :key="idx">
														{{ ev }}
													</li>
												</ul>
											</div>
										</div>
									</v-tooltip>

									<v-btn v-else x-small color="primary" class="text-capitalize" @click="createStaff(item)">
										{{ $t('create') }}
									</v-btn>
								</td>
							</tr>
						</template>
					</v-data-table>
				</v-radio-group>
			</v-card>
		</v-col>
		<!-- TODO:  Not Mapped Table -->
		<v-col
			cols="6"
			:style="{
				height: selectedEcpUser !== null && selectedNotMappedUser !== null ? height : '50%',
			}">
			<v-card elevation="5" height="100%">
				<div class="d-flex justify-space-between elevation-3">
					<div class="d-flex align-center">
						<v-img :src="logoDrawer" class="ml-2" max-height="21" max-width="22" />
						<div class="text-left ml-2 font-weight-bold font-size16">
							{{ $t('unmapped-medical-staff') }}
						</div>
					</div>
					<div>
						<v-text-field
							single-line
							outlined
							class="py-1 px-1"
							prepend-inner-icon="mdi-magnify"
							hide-details
							dense
							v-model="searchNotMappedMedicalStaff"
							:label="$t('search')" />
					</div>
				</div>
				<v-divider />
				<v-radio-group v-model="selectedNotMappedUser" hide-details class="small">
					<v-data-table
						:loading="loading"
						:headers="staffHeaders"
						:items="
							itemsFiltered.notMappedUsers.length === 0 ? unfiltered.notMappedUsers : itemsFiltered.notMappedUsers
						"
						:search="searchNotMappedMedicalStaff"
						:height="tableHeight"
						fixed-header
						:footer-props="getDataTableFooterProps('medicalStaffMappingTable')"
						:items-per-page="-1"
						:no-data-text="$t('no-data-available')">
						<template #item="{ item }">
							<tr :ref="(el) => setRowRef(item.id, el)" :class="{ 'highlight-row': highlightedId === item.id }">
								<td style="height: 30px !important" class="table-font-size px-2 py-0">
									<div class="d-flex">
										<v-icon
											style="font-size: 12px !important"
											class="mr-1"
											x-small
											:class="getStatusIcons(item.status)">
											mdi-checkbox-blank-circle
										</v-icon>
										<v-img class="mr-2" :src="PatientBlack" max-width="13px" max-height="20px" />
										{{ item.firstName }}
										{{ item.lastName }}
									</div>
								</td>
								<td style="height: 30px !important" class="table-font-size">
									{{ item.email }}
								</td>
								<td style="height: 30px !important" class="table-font-size">
									{{ item.phone }}
								</td>
								<td style="height: 30px !important" class="table-font-size px-2 py-0 pr-6">
									<div class="d-flex justify-space-between align-center">
										{{ getRoleName(item.role) }}
										<v-radio v-if="showRadioButton" :value="item"></v-radio>
									</div>
								</td>
							</tr>
						</template>
					</v-data-table>
				</v-radio-group>
			</v-card>
		</v-col>
		<!-- TODO:  BUTTON -->
		<v-col
			cols="12"
			class="py-2"
			v-if="selectedEcpUser !== null && selectedNotMappedUser !== null"
			style="height: 52px">
			<v-btn @click="mapUser" color="primary2" block>
				<span style="text-transform: capitalize" class="font-size15 white--text">Map User</span>
			</v-btn>
		</v-col>
		<!--   TODO: MAPPED USERS   -->
		<v-col
			cols="12"
			:style="{
				height: selectedEcpUser !== null && selectedNotMappedUser !== null ? height : '50%',
			}">
			<v-card elevation="5" height="100%">
				<div class="d-flex justify-space-between elevation-3">
					<div class="d-flex align-center">
						<v-img class="ml-2" :src="DoctorBlack" max-width="18px" max-height="20px" />
						<div class="text-left ml-1 font-weight-bold font-size16">{{ $t('mapped-staff') }}</div>
					</div>
					<div>
						<v-text-field
							single-line
							outlined
							class="py-1 px-1"
							prepend-inner-icon="mdi-magnify"
							hide-details
							dense
							v-model="searchMappedMedicalStaff"
							:label="$t('search')" />
					</div>
				</div>
				<v-divider />
				<div>
					<v-data-table
						:loading="loading"
						:headers="mappedUsersHeaders"
						:items="unfiltered.mappedUsers"
						:search="searchMappedMedicalStaff"
						:height="tableHeight"
						fixed-header
						:footer-props="getDataTableFooterProps('medicalStaffMappingTable')"
						:items-per-page="-1"
						:no-data-text="$t('no-data-available')">
						<template #item="{ item, index }">
							<tr :class="getOddRows(index)">
								<td style="height: 30px !important" class="table-font-size px-2 py-0">
									<div class="d-flex align-center">
										<div class="d-flex align-center" style="min-width: 80px">
											<v-chip x-small hide-details :color="getColorStatus(item.status)">
												{{ getStatus(item.status) }}
											</v-chip>
										</div>
										<div>
											<span>{{ item.firstName }} {{ item.lastName }}</span>
										</div>
									</div>
								</td>
								<td style="height: 30px !important" class="table-font-size px-2 py-0">
									<div class="d-flex justify-end align-center">
										{{ getRoleName(item.role) }}
										<v-icon class="pl-4" @click="openDeleteDialog(item)" size="18" color="primary"
											>mdi mdi-delete</v-icon
										>
									</div>
								</td>
							</tr>
						</template>
					</v-data-table>
				</div>
			</v-card>
		</v-col>
	</v-row>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { ecp, logoDrawer, patientBlack, doctorBlack } from '@/assets';
import MappingRepository from '@/data/repositories/v1/MappingRepository.js';
import UsersRepository from '@/data/repositories/v1/UsersRepository';
import { getDataTableFooterProps } from '@/utils/utilities';
import { ref } from 'vue';

const rowRefs = ref({});

export default {
	data () {
		return {
			PatientBlack: patientBlack,
			DoctorBlack: doctorBlack,
			deleteDialog: false,
			patientToDelete: null,
			staff: null,
			dialog: false,
			loading: false,
			showRadioButton: false,
			selectedEcpUser: null,
			selectedNotMappedUser: null,
			searchEcpMedicalStaff: '',
			searchNotMappedMedicalStaff: '',
			searchMappedMedicalStaff: '',
			unfiltered: {
				notMappedUsers: [],
				mappedUsers: [],
				usersNeedToBeMapped: [],
			},
			itemsFiltered: {
				notMappedUsers: [],
				mappedUsers: [],
				usersNeedToBeMapped: [],
			},
			ecpHeaders: [
				{ text: this.$t('name'), value: 'userFirstName' },
				{ text: this.$t('email'), value: 'email' },
				{ text: this.$t('phone'), value: 'phone' },
				{ text: this.$t('role'), value: 'userRole', align: 'start' },
				{ text: '', value: '', width: '50' },
			],
			staffHeaders: [
				{ text: this.$t('name'), value: 'firstName', class: 'height15-black text-no-wrap' },
				{ text: this.$t('email'), value: 'firstName', class: 'height15-black' },
				{ text: this.$t('phone'), value: 'firstName', class: 'height15-black' },
				{ text: this.$t('role'), value: 'role', class: 'height15-black pl-2', align: 'start' },
			],
			mappedUsersHeaders: [
				{ text: this.$t('name'), value: 'firstName', class: 'height15-black' },
				{ text: this.$t('role'), value: 'role', class: 'height15-black pr-10', align: 'end' },
			],
			highlightedId: null,
			tableHeight: '300px',
		};
	},
	computed: {
		logoDrawer () {
			return logoDrawer;
		},
		ecp () {
			return ecp;
		},
		...mapState({
			userData: (state) => state.authentication.userData,
			selectedHospitalId: (state) => state.filterbar.hospitalId,
			medicalInstitution: (state) => state.filterbar.medicalInstitution,
		}),
		...mapGetters({
			roleName: 'authentication/getRole',
			userSettings: 'authentication/getUserSettings',
		}),
		roleIsSystemAdmin () {
			return this.roleName === 'SYSTEM_ADMIN' || this.roleName === 'SYSTEM_USER';
		},
		height () {
			return this.roleIsSystemAdmin ? 'calc((100vh - 184px) / 2)' : 'calc((100vh - 129px) / 2)';
		},
	},
	created () {
		this.getECPUsersMappings();
		window.addEventListener('resize', this.updateDataTableHeight);
	},
	mounted () {
		setTimeout(() => {
			this.updateDataTableHeight();
		}, 100);
	},
	watch: {
		selectedHospitalId: {
			handler () {
				this.getECPUsersMappings();
			},
			deep: true,
		},
		selectedEcpUser (newVal, oldVal) {
			if (oldVal === null && newVal !== null) {
				this.updateDataTableHeight();
			}
		},
		selectedNotMappedUser (newVal, oldVal) {
			if (oldVal === null && newVal !== null) {
				this.updateDataTableHeight();
			}
		},
	},
	methods: {
		scrollToRow (desiredId) {
			const el = rowRefs.value[desiredId];
			if (el) {
				el.scrollIntoView({
					behavior: 'smooth',
					block: 'center',
				});

				// set highlight
				this.highlightedId = desiredId;
			}
		},
		setRowRef (id, el) {
			if (el) {
				rowRefs.value[id] = el;
			}
		},
		getECPUsersMappings () {
			switch (this.roleName) {
				case 'SYSTEM_ADMIN':
					if (this.selectedHospitalId !== null) {
						this.getUsersForMapping();
					}
					return;
				case 'SYSTEM_USER':
					if (this.selectedHospitalId !== null) {
						this.getUsersForMapping();
					}
					return;
				case 'HOSPITAL_ADMIN':
					this.getUsersForMapping();
					break;
				case 'DOCTOR':
					this.getUsersForMapping();
					break;
				case 'NURSE':
					this.getUsersForMapping();
					break;
			}
		},
		getColorStatus (status) {
			switch (status) {
				case 1:
					return 'background-green-dot-status';
				case 10:
					return 'background-red-dot-status';
				default:
					return 'grey';
			}
		},
		getStatus (status) {
			switch (status) {
				case 1:
					return this.$t('active');
				case 10:
					return this.$t('deleted');
				default:
					return this.$t('inactive');
			}
		},
		getStatusIcons (status) {
			switch (status) {
				case 1:
					return 'color-green';
				default:
					return '';
			}
		},
		getOddRows (index) {
			if (index % 2 === 1) {
				return 'odd-row';
			}
			if (index % 2 === 0) {
				return 'even-row';
			}
		},
		getDataTableFooterProps,
		confirmCreate () {
			UsersRepository.createStaff(this.staff.id).then(() => {
				this.getUsersForMapping();
				this.dialog = false;
			});
		},
		createStaff (item) {
			this.dialog = true;
			this.staff = item;
		},
		confirmDeletion () {
			MappingRepository.deleteMappedUser(this.patientToDelete).then(() => {
				this.getUsersForMapping();
				this.searchEcpPatient = '';
				this.searchNotMappedPatient = '';
				this.searchMappedPatient = '';
				this.selectedNotMappedUser = null;
				this.selectedEcpUser = null;
				this.deleteDialog = false;
			});
		},
		openDeleteDialog (item) {
			this.patientToDelete = item.id;
			this.deleteDialog = true;
		},
		filterByRole (item) {
			var tempNotMappedUsers = this.unfiltered.notMappedUsers;
			if (item.userRole === 'Caregiver') {
				this.itemsFiltered.notMappedUsers = tempNotMappedUsers.filter((user) => user.role === 7);
				this.showRadioButton = true;
			}
			if (item.userRole === 'Nursing') {
				this.itemsFiltered.notMappedUsers = tempNotMappedUsers.filter((user) => user.role === 4);
				this.showRadioButton = true;
			}

			const suggestionWithNotMappedUser = this.itemsFiltered.notMappedUsers.find(
				(p) => p.id === this.selectedEcpUser.userMapSuggestion?.localUserId,
			);

			this.selectedNotMappedUser = suggestionWithNotMappedUser;
			this.scrollToRow(suggestionWithNotMappedUser.userMapSuggestion.localUserId);
		},
		getRoleName (roleId) {
			switch (roleId) {
				case 3:
					return 'Doctor';
				case 4:
					return 'Nurse';
				case 7:
					return 'Caregiver';
				default:
					return '';
			}
		},
		getUsersForMapping () {
			this.loading = true;
			let selectedHospitalId = null;
			if (this.roleName === 'HOSPITAL_ADMIN') {
				selectedHospitalId = this.userData.hospitalAssignedData.id;
			} else if (this.roleName === 'DOCTOR' || this.roleName === 'NURSE') {
				selectedHospitalId = Number(localStorage.getItem('selectedHospitalAssignedId')) || 0;
			} else {
				selectedHospitalId = this.selectedHospitalId;
			}

			MappingRepository.getMappedEcpMedicalStaffForHospital(selectedHospitalId).then((response) => {
				this.unfiltered = response;
				this.loading = false;
				this.itemsFiltered.notMappedUsers = this.unfiltered.notMappedUsers;
				this.showRadioButton = false;
			});
		},
		mapUser () {
			this.loading = true;
			let selectedHospitalId = null;
			let selectedOrganizationId = null;
			if (this.roleName === 'HOSPITAL_ADMIN') {
				selectedHospitalId = this.userData.hospitalAssignedData.id;
				selectedOrganizationId = this.userData.organizationId;
			} else if (this.roleName === 'DOCTOR' || this.roleName === 'NURSE') {
				selectedHospitalId = Number(localStorage.getItem('selectedHospitalAssignedId')) || 0;
				selectedOrganizationId = this.userData.organizationId;
			} else {
				selectedHospitalId = this.selectedHospitalId;
				selectedOrganizationId = this.medicalInstitution;
			}

			const body = {
				ecpUserId: this.selectedEcpUser?.userId || 'string',
				ecpLocationId: this.selectedEcpUser?.ecpLocationId || null,
				mappedUserId: this.selectedNotMappedUser?.id || 0,
				mappedHospitalId: selectedHospitalId,
				mappedOrganizationId: selectedOrganizationId,
				firstName: this.selectedEcpUser?.userFirstName,
				lastName: this.selectedEcpUser?.userLastName,
			};

			MappingRepository.mapUser(body).then((response) => {
				if (response.resFlag) {
					this.getUsersForMapping();
					this.selectedNotMappedUser = null;
					this.selectedEcpUser = null;
					this.searchEcpMedicalStaff = '';
					this.searchNotMappedMedicalStaff = '';
					this.searchMappedMedicalStaff = '';
				} else this.loading = false;
			});
		},
		deleteMappedUser (item) {
			MappingRepository.deleteMappedUser(item.id).then(() => {
				this.getUsersForMapping();
				this.searchEcpMedicalStaff = '';
				this.searchNotMappedMedicalStaff = '';
				this.searchMappedMedicalStaff = '';
				this.selectedNotMappedUser = null;
				this.selectedEcpUser = null;
			});
		},
		clickUserNeedToBeMap (item) {
			this.filterByRole(item);
			const suggestionWithNotMappedResident = this.items.notMappedUsers.find(
				(p) => p.id === this.selectedEcpUser.userMapSuggestion?.localUserId,
			);

			this.selectedNotMappedUser = suggestionWithNotMappedResident;
			this.scrollToRow(suggestionWithNotMappedResident.userMapSuggestion.localUserId);
		},
		updateDataTableHeight () {
			this.$nextTick(() => {
				if (this.$refs.ecpUsersTable) {
					this.tableHeight = this.$refs.ecpUsersTable.$el.clientHeight - 109 + 'px';
				}
			});
		},
	},
};
</script>

<style lang="scss">
.v-messages {
	display: none !important;
}

.small i {
	font-size: 18px !important;
}

.small [class*='__ripple'] {
	left: 0;
	display: none;
}

.small {
	margin: 0px;
	padding: 0px;
}

.highlight-row {
	animation: blink-bg 1s ease-in-out infinite;
}

@keyframes blink-bg {
	0%,
	100% {
		background-color: transparent;
	}

	50% {
		background-color: #d1d1d1;
	}
}
</style>
